import { useEffect } from "react";
import { TourGuideClient } from "@sjmc11/tourguidejs";
import { tourSteps } from "./tourSteps";
import { useHistory } from "react-router-dom";
import "./custom-Tour.scss";

export const AppTour = () => {
  const his = useHistory();

  useEffect(() => {

    // 👉 Se já viu o tour, não inicia novamente
    const tourVisto = localStorage.getItem("tourVisto");
    if (tourVisto) {
      console.log("Tour já foi exibido anteriormente.");
      return;
    }

    const tg: any = new TourGuideClient({
      steps: tourSteps,
      autoScroll: true,
      nextLabel: "Próximo",
      prevLabel: "Voltar",
      finishLabel: "Concluir",
      backdropColor: "rgba(0, 0, 0, 0.6)",
    });

    tg.onBeforeStepChange((...args: any[]) => {
      console.log("args", args);

      return new Promise((resolve) => {
        const stepPageMap = {
          0: "/dashboard",
          1: "/dashboard",
          2: "/dashboard",
          3: "/dashboard",
          4: "/wallet",
          5: "/wallet",
          6: "/analysis",
          7: "/analysis",
          8: "/renda-passiva",
          9: "/simuladores",
          10: "/imposto-renda",
          11: "/cursos-gratuitos",
        };

        const step = args[1];
        const actualPage = window.location.pathname;
        const tobePage = (stepPageMap as any)[step || 1];

        console.log({ actualPage, tobePage, step });

        if (actualPage !== tobePage) {
          his.push(tobePage);
          return setTimeout(() => resolve(true), 1000);
        }

        return resolve(true);
      });
    });

    // 👉 Marca como visto quando o tour finalizar normalmente
    tg.onFinish(() => {
      localStorage.setItem("tourVisto", "true");
    });

    // 👉 Marca como visto se o usuário fechar o tour (cancelar)
    tg.onAfterExit(() => {
      localStorage.setItem("tourVisto", "true");
    });

    const startTour = () => {
      setTimeout(() => {
        tg.start();
      }, 1500);
    };

    startTour();

    return () => typeof tg?.end === "function" && tg.end();
  }, []);

  return <></>;
};
